import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { SettingsProvider } from './../../providers/settings/settings';


/*
  Generated class for the PaycassoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PaycassoProvider {

  constructor(public gateway: GatewayClientProvider,
    public settingsProvider: SettingsProvider, public http: Http) {

  }
  start_session(consumer_ref) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.p_start_session(consumer_ref)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  authorisedlogin() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.p_authorisedlogin()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  newTransaction(bodyParam) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.p_newtransaction(bodyParam)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  uploadFront(bodyParam) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.P_uploadFront(bodyParam)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  uploadBack(bodyParam) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.P_uploadBack(bodyParam)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  GetSummary() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.P_GetSummary()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/paycasso/paycasso.ts